export const routes = {
	login: "/"
	, totalPage: "/pump/total_page"
	, firePage: "/pump/fire_page"
	, waterPage: "/pump/water_page"
	, drainagePage: "/pump/drainage_page"
	, boardPage: "/management/board/board_page"
	, boardDetail: "/management/board/board_detail"
	, boardRegister: "/management/board/board_register"
	, userPage: "/management/user/user_page"
	, userDetail: "/management/user/user_detail"
	, userRegister: "/management/user/user_register"
	, facilityPage: "/management/facility/facility_page"
	, facilityDetail: "/management/facility/facility_detail"
	, facilityRegister: "/management/facility/facility_register"
	, terminalPage: "/management/terminal/terminal_page"
	, terminalDetail: "/management/terminal/terminal_detail"
	, terminalRegister: "/management/terminal/terminal_register"
	, termsPage: "/management/terms/terms_page"
	, termsDetail: "/management/terms/terms_detail"
	, termsRegister: "/management/terms/terms_register"
	, servicePage: "/management/warranty/warranty_service_page"
	, serviceDetail: "/management/warranty/warranty_service_manage"
	, serviceRegister: "/management/warranty/warranty_service_register"
}